"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var _input = require("../../input");
var _PercentageToggler = _interopRequireDefault(require("./PercentageToggler"));
var _Searchable = _interopRequireDefault(require("./Searchable.style"));
var _InputError = _interopRequireDefault(require("../../errors/InputError"));
var _helpers = require("./helpers");
var _SearchableDropdown = _interopRequireDefault(require("./SearchableDropdown"));
var _tooltip = require("../../tooltip");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialState = {
  search: '',
  isSearching: false,
  searchData: []
};
var MIN_CHAR_COUNT = 3;
var MAX_NUMBER_CHAR_COUNT = 17;
var Searchable = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Searchable, _React$PureComponent);
  var _super = _createSuper(Searchable);
  function Searchable(props) {
    var _this;
    _classCallCheck(this, Searchable);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onChangeNumeric", function (value) {
      var _this$props = _this.props,
        type = _this$props.type,
        maxLength = _this$props.maxLength;
      var numericValue = (0, _utils.safeSlice)((0, _helpers.processNumeric)(value), 0, maxLength);
      var data = (0, _helpers.getFieldPayload)({
        value: numericValue,
        type: type === _helpers.SEARCHABLE_TYPES.NUMERIC_PERCENTAGE ? _helpers.SEARCHABLE_TYPES.NUMERIC_PERCENTAGE : _helpers.SEARCHABLE_TYPES.NUMERIC_SIMPLE
      });
      _this.props.formulaChange(data);
    });
    _defineProperty(_assertThisInitialized(_this), "onChangeExternal", function (value) {
      var hasCustomClickAction = _this.props.hasCustomClickAction;
      _this.setState({
        search: value
      });
      if (hasCustomClickAction && value.length < MIN_CHAR_COUNT) return;
      _this.setState({
        isSearching: true
      });
      _this.search(value);
    });
    _defineProperty(_assertThisInitialized(_this), "onChange", function (ev) {
      var value = R.path(['target', 'value'], ev);
      var _this$props2 = _this.props,
        hasCustomClickAction = _this$props2.hasCustomClickAction,
        allowNumeric = _this$props2.allowNumeric;
      if ((0, _utils.isBlank)(value)) {
        _this.props.formulaChange((0, _helpers.getFieldPayload)({}));
        return _this.setState(_objectSpread({}, initialState));
      }
      if (allowNumeric && (0, _helpers.isNumericValue)(value) && !hasCustomClickAction) {
        _this.onChangeNumeric(value);
      } else {
        _this.onChangeExternal(value);
      }
      return ev;
    });
    _defineProperty(_assertThisInitialized(_this), "handlingSearchableAction", function (searchValue) {
      _this.props.searchableAction(searchValue).then(function (data) {
        _this.setState({
          searchData: data,
          isSearching: false
        });
      })["catch"](function () {
        return _this.setState({
          searchData: [],
          isSearching: false
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "search", (0, _utils.debounce)(function (searchValue) {
      return _this.props.allowSearch && _this.handlingSearchableAction(searchValue);
    }, 300));
    _defineProperty(_assertThisInitialized(_this), "changeFieldType", function (_ref) {
      var type = _ref.type;
      var data = (0, _helpers.getFieldPayload)(_objectSpread(_objectSpread({}, _this.props), {}, {
        type: type
      }));
      _this.props.formulaChange(data);
    });
    _defineProperty(_assertThisInitialized(_this), "itemClick", function (item) {
      var data = (0, _helpers.getFieldPayload)(_objectSpread(_objectSpread({}, item), {}, {
        type: _helpers.SEARCHABLE_TYPES.EXTERNAL
      }));
      _this.props.formulaChange(data);
      _this.setState(data);
    });
    _defineProperty(_assertThisInitialized(_this), "renderActionContent", function (_ref2) {
      var isNumeric = _ref2.isNumeric;
      var _this$props3 = _this.props,
        type = _this$props3.type,
        allowSearch = _this$props3.allowSearch,
        allowPercentageToggler = _this$props3.allowPercentageToggler,
        searchLengthTrigger = _this$props3.searchLengthTrigger,
        listRenderer = _this$props3.listRenderer,
        labels = _this$props3.labels,
        isFocused = _this$props3.isFocused,
        hasCustomClickAction = _this$props3.hasCustomClickAction,
        isFullWidth = _this$props3.isFullWidth;
      var _this$state = _this.state,
        searchData = _this$state.searchData,
        search = _this$state.search,
        isSearching = _this$state.isSearching;
      if (isNumeric && allowPercentageToggler) {
        return /*#__PURE__*/_react["default"].createElement(_PercentageToggler["default"], {
          onTypeChange: _this.changeFieldType,
          type: type
        });
      }
      if (!isNumeric && allowSearch && search.length >= searchLengthTrigger) {
        return /*#__PURE__*/_react["default"].createElement(_SearchableDropdown["default"], {
          searchData: searchData,
          isSearching: isSearching,
          search: search,
          isFocused: isFocused,
          labels: labels,
          itemClick: hasCustomClickAction ? function (item) {
            return _this.props.itemClick(item);
          } : _this.itemClick,
          isFullWidth: isFullWidth
        }, listRenderer);
      }
      return null;
    });
    _this.state = _objectSpread({}, initialState);
    return _this;
  }
  _createClass(Searchable, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        id = _this$props4.id,
        labels = _this$props4.labels,
        error = _this$props4.error,
        isFocused = _this$props4.isFocused,
        disabled = _this$props4.disabled,
        value = _this$props4.value,
        displayName = _this$props4.displayName,
        description = _this$props4.description,
        type = _this$props4.type,
        inputType = _this$props4.inputType,
        uniqueKey = _this$props4.uniqueKey,
        hasCustomClickAction = _this$props4.hasCustomClickAction,
        isFullWidth = _this$props4.isFullWidth,
        placeholder = _this$props4.placeholder,
        clearable = _this$props4.clearable,
        searchIcon = _this$props4.searchIcon,
        onClearIcon = _this$props4.onClearIcon,
        tooltipPosition = _this$props4.tooltipPosition,
        ariaLabel = _this$props4.ariaLabel,
        component = _this$props4.component,
        maxLength = _this$props4.maxLength;
      var search = this.state.search;
      var isNumeric = (0, _helpers.isNumericType)(type);
      var InputComponent = component || _input.Input;
      return /*#__PURE__*/_react["default"].createElement(_Searchable["default"], {
        "data-testid": "searchable-wrapper",
        "data-tip": (0, _helpers.getFieldDescription)({
          type: type,
          value: value,
          description: description
        }),
        "data-place": tooltipPosition,
        "data-for": "tip-".concat(uniqueKey || value),
        isNumeric: isNumeric,
        isFullWidth: isFullWidth,
        isFocused: isFocused,
        searchIcon: searchIcon,
        disabled: disabled,
        error: error,
        value: value
      }, !search.length && !hasCustomClickAction && /*#__PURE__*/_react["default"].createElement(_tooltip.Tooltip, {
        id: "tip-".concat(uniqueKey || value)
      }), /*#__PURE__*/_react["default"].createElement(InputComponent, {
        id: id,
        disabled: disabled,
        value: (0, _helpers.getFieldDescription)({
          value: value,
          type: type,
          description: description,
          isFocused: isFocused,
          search: search,
          displayName: displayName
        }),
        type: isNumeric ? 'number' : inputType,
        onChange: this.onChange,
        onBlur: function onBlur() {
          _this2.setState({
            isSearching: false,
            searchData: [],
            search: ''
          });
        },
        placeholder: placeholder || labels.FORMULA_INPUT_PLACEHOLDER,
        clearable: clearable,
        iconClick: onClearIcon,
        inputAriaLabel: ariaLabel,
        maxLength: maxLength
      }), isFocused && !disabled && this.renderActionContent({
        isNumeric: isNumeric
      }), error && /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
        message: labels.RULES_BUILDER_VARIABLE_MISSING
      }));
    }
  }]);
  return Searchable;
}(_react["default"].PureComponent);
var ListRenderer = function ListRenderer(_ref3) {
  var item = _ref3.item,
    itemClick = _ref3.itemClick;
  return /*#__PURE__*/_react["default"].createElement("li", {
    key: item.description.toString()
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onMouseDown: function onMouseDown() {
      return itemClick(item);
    }
  }, item.description));
};
ListRenderer.propTypes = {
  item: _propTypes["default"].shape({
    description: _propTypes["default"].string
  }).isRequired,
  itemClick: _propTypes["default"].func.isRequired
};
Searchable.defaultProps = {
  id: '',
  allowNumeric: true,
  allowSearch: true,
  allowPercentageToggler: true,
  maxLength: MAX_NUMBER_CHAR_COUNT,
  listRenderer: ListRenderer,
  disabled: false,
  error: undefined,
  value: '',
  type: '',
  inputType: null,
  isFocused: false,
  displayName: '',
  description: '',
  uniqueKey: '',
  itemClick: _utils.noop,
  hasCustomClickAction: false,
  isFullWidth: true,
  searchLengthTrigger: 1,
  tooltipPosition: 'bottom',
  placeholder: '',
  clearable: false,
  searchIcon: '',
  onClearIcon: _utils.noop,
  ariaLabel: '',
  component: null
};
Searchable.propTypes = {
  id: _propTypes["default"].string,
  allowNumeric: _propTypes["default"].bool,
  allowSearch: _propTypes["default"].bool,
  allowPercentageToggler: _propTypes["default"].bool,
  maxLength: _propTypes["default"].number,
  listRenderer: _propTypes["default"].func,
  uniqueKey: _propTypes["default"].string,
  tooltipPosition: _propTypes["default"].oneOf(['top', 'bottom']),
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]),
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  type: _propTypes["default"].string,
  inputType: _propTypes["default"].string,
  displayName: _propTypes["default"].string,
  description: _propTypes["default"].string,
  isFocused: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  formulaChange: _propTypes["default"].func.isRequired,
  searchableAction: _propTypes["default"].func.isRequired,
  itemClick: _propTypes["default"].func,
  hasCustomClickAction: _propTypes["default"].bool,
  isFullWidth: _propTypes["default"].bool,
  searchLengthTrigger: _propTypes["default"].number,
  placeholder: _propTypes["default"].string,
  searchIcon: _propTypes["default"].string,
  /** Flag to indicate if the input should have a clearvalue action. */
  clearable: _propTypes["default"].bool,
  /** An action to perform when clicking on the icon on the clear button */
  onClearIcon: _propTypes["default"].func,
  ariaLabel: _propTypes["default"].string,
  component: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].object])
};
Searchable.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onChangeNumeric",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onChangeExternal",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "ev",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handlingSearchableAction",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "searchValue",
      "type": null
    }],
    "returns": null
  }, {
    "name": "changeFieldType",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "{ type }",
      "type": null
    }],
    "returns": null
  }, {
    "name": "itemClick",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "item",
      "type": null
    }],
    "returns": null
  }, {
    "name": "renderActionContent",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "{ isNumeric }",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Searchable",
  "props": {
    "id": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "allowNumeric": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "allowSearch": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "allowPercentageToggler": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "maxLength": {
      "defaultValue": {
        "value": "17",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "listRenderer": {
      "defaultValue": {
        "value": "({ item, itemClick }) => (\r\n  <li key={item.description.toString()}>\r\n    <button onMouseDown={() => itemClick(item)}>{item.description}</button>\r\n  </li>\r\n)",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "error": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "bool"
        }]
      },
      "required": false
    },
    "value": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false
    },
    "type": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "inputType": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "isFocused": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "displayName": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "description": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "uniqueKey": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "itemClick": {
      "defaultValue": {
        "value": "noop",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "hasCustomClickAction": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "isFullWidth": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "searchLengthTrigger": {
      "defaultValue": {
        "value": "1",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "tooltipPosition": {
      "defaultValue": {
        "value": "'bottom'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'top'",
          "computed": false
        }, {
          "value": "'bottom'",
          "computed": false
        }]
      },
      "required": false
    },
    "placeholder": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "clearable": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to indicate if the input should have a clearvalue action.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "searchIcon": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onClearIcon": {
      "defaultValue": {
        "value": "noop",
        "computed": true
      },
      "description": "An action to perform when clicking on the icon on the clear button",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "ariaLabel": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "component": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "element"
        }, {
          "name": "object"
        }]
      },
      "required": false
    },
    "labels": {
      "description": "",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": true
    },
    "formulaChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "searchableAction": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};
var _default = Searchable;
exports["default"] = _default;